import { createFileRoute, redirect } from '@tanstack/react-router';
import ReceptionPortal from '../components/portals/ReceptionPortal';

export const Route = createFileRoute('/reception/reservations/new')({
  beforeLoad: ({ search }) => {
    throw redirect({ to: '/reception/orders/new', search });
  },
  component: ReceptionLegacyNewReservationRoute,
});

function ReceptionLegacyNewReservationRoute() {
  return (
    <ReceptionPortal>
      <div />
    </ReceptionPortal>
  );
}
